'use strict';

module.exports = function($stateProvider) {

    $stateProvider
        .state('dashboard.departments.department.forms.form', {
            url: '/:formId',
            templateUrl: 'dashboard-form/dashboard-form.html',
            controller: 'dashboardFormCtrl as ctrl',
            abstract: true,
            resolve: {
                teams: ['Department', '$stateParams', function(Department, $stateParams) {
                    return Department.teams({
                        id: $stateParams.departmentId,
                        filter: {
                            include: [{
                                relation: 'subscribedTo',
                                scope: {
                                    fields: 'id'
                                }
                            }, {
                                relation: 'members',
                                scope: {
                                    fields: 'id'
                                }
                            }]
                        }
                    }).$promise.then(function(teams) {
                        return teams;
                    });

                }],
                items: ['Department', '$stateParams', function(Department, $stateParams) {
                    return Department.forms({
                            id: $stateParams.departmentId,
                            filter: {
                                fields: 'id',
                                where: {
                                    id: $stateParams.formId
                                }
                                
                            }
                        })
                        .$promise.then(function(forms) {
                            if (!forms.length) {
                                return [];
                            }
                            forms = forms[0];
                            return forms.items || [];
                        });

                }]
            },
            data: {
                authorizedRoles: ['admin', 'mobileUser']
            }
        });
};
